import * as React from 'react';

import PageWrapper from '~/common/layout/PageWrapper';
import Logout from '~/apps/shared/containers/app/Logout';


export default function() {
  return (
    <React.Fragment>
      <PageWrapper>
        <Logout />
      </PageWrapper>
    </React.Fragment>
  );
};
